import { defineStore } from "pinia";
import { computed, Ref } from "vue";
import { useLocalStorage } from "@vueuse/core";

type SettingType = {
  locale: string;
  darkMode: boolean;
  soonExpirationDialogNotShow: string[];
  expiredCodeDialogNotShow: string[];
};

export const useSettingStore = defineStore("setting", () => {
  const setting: Ref<SettingType> = useLocalStorage(
    `forme_b2c_${process.env.VUE_APP_ENV}/setting`,
    {
      locale: "ko",
      darkMode: false,
    } as SettingType
  );

  const getSetting = computed(() => {
    return setting.value;
  });

  function setSetting(newSetting: Partial<SettingType>) {
    setting.value = { ...setting.value, ...newSetting };
  }

  return {
    setting,
    setSetting,
    getSetting,
  };
});
